import { useParams, useNavigate, useSearchParams } from "react-router";
import { Box, Button, Container, Typography } from "@mui/material";
import { FactoringImageGallery } from "components/FactoringImageGallery.tsx";

export default function FactoringDetailImages() {
  const { factoringId } = useParams<{ factoringId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBackToDetail = () => {
    // Get the returnPage parameter from the URL
    const returnPage = searchParams.get("returnPage");
    if (returnPage) {
      // Navigate back to the details with the returnPage parameter
      navigate(`/factoring/${factoringId}/details?returnPage=${returnPage}`);
    } else {
      // If no returnPage parameter, just navigate back to the details
      navigate(`/factoring/${factoringId}/details`);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        画像詳細
      </Typography>

      {factoringId && <FactoringImageGallery factoringId={factoringId} />}

      <Box sx={{ mt: 3 }}>
        <Button variant="outlined" onClick={handleBackToDetail}>
          詳細へ戻る
        </Button>
      </Box>
    </Container>
  );
}
